export default "__VITE_ASSET__b52ae873__"